/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { t, terminationGrounds, calc4Ext, calcCommon } from '../../utils/calculatorTranslations'
import { PageContext } from '../../context/PageContextProvider'
import { useState, useContext, useEffect, useMemo } from 'react'
import { Calculator, Info, Attention } from '../../icons'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import {
  STATUTORY_CONSTANTS,
  getStatutorySeveranceMultiplier,
  getStatutoryNoticeDays,
  getStatutoryNoticeMultiplier,
  calculateNoticeCompensation,
  calculateStatutoryMinimumSeverance,
  checkAdditionalVacationEligibility,
  calculateIncomeTax2026,
  calculateMDSS2026,
  calculateITS2026,
  calculateISS2026,
  calculateFinalSettlement2026,
} from './terminationCalculator2026'

const TERMINATION_GROUNDS = [
  { id: '70_b', label: 'ƏM m.70 (b) — İşçilərin sayının və ya ştatların ixtisarı (İxtisar)' },
  { id: '70_a', label: 'ƏM m.70 (a) — Müəssisənin ləğv edilməsi' },
  { id: '70_c', label: 'ƏM m.70 (c) — Peşəkarlıq səviyyəsinin uyğun gəlməməsi (attestasiya)' },
  { id: '70_ch', label: 'ƏM m.70 (ç) — Vəzifə öhdəliklərinin kobud şəkildə pozulması' },
  { id: '68_2_a', label: 'ƏM m.68.2 (a) — Tərəflərin qarşılıqlı razılığı ilə' },
  { id: '68_2_b', label: 'ƏM m.68.2 (b) — Müddətli əmək müqaviləsinin müddətinin bitməsi' },
  { id: '69', label: 'ƏM m.69 — İşçinin öz təşəbbüsü ilə (ərizəsi əsasında) istefası' },
  { id: '74_1_a', label: 'ƏM m.74.1 (a) — Hərbi və ya alternativ xidmətə çağırılma (azı 2.0x OMA)' },
  { id: '74_1_b', label: 'ƏM m.74.1 (b) — Əvvəlki işçinin məhkəmə qərarı ilə işə bərpası' },
  { id: '74_1_c', label: 'ƏM m.74.1 (c) — Əmək qabiliyyətinin 6 aydan çox fasiləsiz itirilməsi (azı 2.0x OMA)' },
  { id: '74_1_ch', label: 'ƏM m.74.1 (ç) — Məhkəmə hökmü ilə azadlıqdan məhrumetmə və ya cəza' },
  { id: '74_1_d', label: 'ƏM m.74.1 (d) — Məhkəmə qərarı ilə fəaliyyət qabiliyyətsizliyi (Xüsusi hüquqi status)' },
  { id: '74_1_e', label: 'ƏM m.74.1 (e) — İşçinin vəfatı və ya itkin düşmüş elan edilməsi (azı 3.0x OMA)' },
  { id: '63_2_and_68_2_ch', label: 'ƏM m.63.2 və 68.2 (ç) — Mülkiyyətçi dəyişməsi səbəbindən rəhbər heyətlə xitam (azı 3.0x OMA)' },
]

const Calculator4 = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])

  // Basic termination parameters
  const [terminationGround, setTerminationGround] = useState('70_b')
  const [seniorityYears, setSeniorityYears] = useState(7)
  const [terminationDate, setTerminationDate] = useState('2026-09-30')

  // Notice parameters (ƏM 77.1 & 77.4) - only if 70_b
  const [hasEmployeeConsent, setHasEmployeeConsent] = useState(true)
  const [elapsedNoticeCalendarDays, setElapsedNoticeCalendarDays] = useState(0)

  // Salary & current month parameters (Blok 0 - TC-65 Etalon: 3400 / 17 * 10 = 2000 AZN)
  const [monthlySalary, setMonthlySalary] = useState(3400)
  const [normDaysInMonth, setNormDaysInMonth] = useState(17)
  const [actualDaysWorkedInMonth, setActualDaysWorkedInMonth] = useState(10)

  // Vacation parameters (Blok 1 & 2)
  const [last12MonthsAverageSalary, setLast12MonthsAverageSalary] = useState(3400)
  const [vacationBreakdown, setVacationBreakdown] = useState([
    { id: 1, yearLabel: '2024/2025 iş ili', unusedDays: 8 },
    { id: 2, yearLabel: '2025/2026 iş ili', unusedDays: 10 },
  ])

  // Additional vacation checklist assistant (Eligibility-based)
  const [showAdditionalWizard, setShowAdditionalWizard] = useState(false)
  const [hasHazardousConditions, setHasHazardousConditions] = useState(false)
  const [hazardousDays, setHazardousDays] = useState(6)
  const [applySeniorityLeave, setApplySeniorityLeave] = useState(true)
  const [gender, setGender] = useState('female')
  const [isSingleFather, setIsSingleFather] = useState(false)
  const [isAdoptiveParent, setIsAdoptiveParent] = useState(false)
  const [childrenUnder14Count, setChildrenUnder14Count] = useState(0)
  const [disabledChildUnder18Count, setDisabledChildUnder18Count] = useState(0)
  const [isLiberatedTerritorySpecialist, setIsLiberatedTerritorySpecialist] = useState(false)

  // Severance base (ƏM 177.2 OMA parameters)
  const [lastTwoMonthsTotalEarnings, setLastTwoMonthsTotalEarnings] = useState(6800)
  const [lastTwoMonthsWorkDays, setLastTwoMonthsWorkDays] = useState(41)
  const [nextMonthWorkDays, setNextMonthWorkDays] = useState(21)

  // Condition 3: actual severance amount vs statutory minimum
  const [actualSeveranceAmount, setActualSeveranceAmount] = useState('')

  useEffect(() => {
    (async () => {
      try {
        const data1 = await PagesAPI.getMagazinePageInfo()
        setInfo(data1?.data || [])
      } catch (e) {}
      setLoad(true)
    })()
  }, [])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  // Dynamic derivatives
  const statutoryNoticeDays = useMemo(() => {
    return getStatutoryNoticeDays(Number(seniorityYears) || 0)
  }, [seniorityYears])

  const statutoryNoticeMultiplier = useMemo(() => {
    return getStatutoryNoticeMultiplier(Number(seniorityYears) || 0)
  }, [seniorityYears])

  const statutorySeveranceMultiplier = useMemo(() => {
    return getStatutorySeveranceMultiplier(Number(seniorityYears) || 0)
  }, [seniorityYears])

  const dailyRateOGQ140 = useMemo(() => {
    const avg = parseFloat(last12MonthsAverageSalary) || 0
    return avg > 0 ? (avg / STATUTORY_CONSTANTS.AVERAGE_MONTH_CALENDAR_DAYS).toFixed(4) : '0.0000'
  }, [last12MonthsAverageSalary])

  const dailyRateOGQ177 = useMemo(() => {
    const earn = parseFloat(lastTwoMonthsTotalEarnings) || 0
    const days = parseFloat(lastTwoMonthsWorkDays) || 0
    return days > 0 ? (earn / days).toFixed(4) : '0.0000'
  }, [lastTwoMonthsTotalEarnings, lastTwoMonthsWorkDays])

  const additionalLeaveCalculation = useMemo(() => {
    return checkAdditionalVacationEligibility({
      seniorityYears: applySeniorityLeave ? (Number(seniorityYears) || 0) : 0,
      hasHazardousConditions,
      hazardousDays: Number(hazardousDays) || 6,
      gender,
      isSingleFather,
      isAdoptiveParent,
      childrenUnder14Count: Number(childrenUnder14Count) || 0,
      disabledChildUnder18Count: Number(disabledChildUnder18Count) || 0,
      isLiberatedTerritorySpecialist,
    })
  }, [
    seniorityYears,
    applySeniorityLeave,
    hasHazardousConditions,
    hazardousDays,
    gender,
    isSingleFather,
    isAdoptiveParent,
    childrenUnder14Count,
    disabledChildUnder18Count,
    isLiberatedTerritorySpecialist,
  ])

  // Vacation breakdown handlers
  const addVacationRow = () => {
    const nextIdx = vacationBreakdown.length + 1
    const currentYear = new Date().getFullYear()
    setVacationBreakdown([
      ...vacationBreakdown,
      {
        id: Date.now(),
        yearLabel: `${currentYear - nextIdx + 1}/${currentYear - nextIdx + 2} iş ili`,
        unusedDays: 0,
      },
    ])
  }

  const removeVacationRow = (id) => {
    if (vacationBreakdown.length <= 1) return
    setVacationBreakdown(vacationBreakdown.filter((item) => item.id !== id))
  }

  const updateVacationRow = (id, field, val) => {
    setVacationBreakdown(
      vacationBreakdown.map((item) => (item.id === id ? { ...item, [field]: val } : item))
    )
  }

  const applyAdditionalDaysToVacation = () => {
    const totalExtra = additionalLeaveCalculation.totalEligibleDaysPerYear
    if (totalExtra <= 0) return
    setVacationBreakdown((prev) => {
      if (prev.length === 0) return prev
      const updated = [...prev]
      const lastIndex = updated.length - 1
      updated[lastIndex] = {
        ...updated[lastIndex],
        unusedDays: Number(updated[lastIndex].unusedDays || 0) + totalExtra,
      }
      return updated
    })
  }

  const handleCalculate = () => {
    const inputPayload = {
      monthlySalary: Number(monthlySalary) || 0,
      normDaysInMonth: Number(normDaysInMonth) || 21,
      actualDaysWorkedInMonth: Number(actualDaysWorkedInMonth) || 21,
      last12MonthsAverageSalary: Number(last12MonthsAverageSalary) || 0,
      vacationBreakdown: vacationBreakdown.map((v) => ({
        yearLabel: v.yearLabel || 'İş ili',
        unusedDays: Number(v.unusedDays) || 0,
      })),
      terminationGround,
      seniorityYears: Number(seniorityYears) || 0,
      hasEmployeeConsent,
      elapsedNoticeCalendarDays: Number(elapsedNoticeCalendarDays) || 0,
      lastTwoMonthsTotalEarnings: Number(lastTwoMonthsTotalEarnings) || 0,
      lastTwoMonthsWorkDays: Number(lastTwoMonthsWorkDays) || 0,
      nextMonthWorkDays: Number(nextMonthWorkDays) || 21,
    }

    const result = calculateFinalSettlement2026(inputPayload)

    // Store in sessionStorage for Result4
    try {
      sessionStorage.setItem(
        'termination_result_2026',
        JSON.stringify({
          ...result,
          actualSeveranceAmount: actualSeveranceAmount ? Number(actualSeveranceAmount) : null,
        })
      )
    } catch (e) {
      console.error(e)
    }

    // Fallback navigation
    const salary = inputPayload.monthlySalary
    const ground = terminationGround
    const seniority = inputPayload.seniorityYears
    const totalGross = result.simulations.modelA.totalGross
    const netA = result.simulations.modelA.netApproachA
    const netB = result.simulations.modelA.netApproachB

    window.location.href = `/useful/calculator/4/result/${salary}/${ground}/${seniority}/${totalGross}/${netA}/${netB}`
  }

  return load ? (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={1} data={steps} />
      </div>

      <h1 className={styles.pageTitle}>
        <Calculator />
        {translate.termination_settlement?.[language] ||
          'Əmək müqaviləsinə xitam və son haqq-hesab kalkulyatoru (2026)'}
      </h1>

      <div className={styles.formCard}>
        {/* Section 1: Xitam Əsası və Staj */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>1</div>
          <div>
            <h3>{language === 'TR' ? 'İş Sözleşmesinin Fesih Nedeni ve Hizmet Süresi' : language === 'ENG' ? 'Termination Grounds & Seniority' : language === 'RU' ? 'Основание расторжения договора и стаж' : 'Əmək Müqaviləsinə Xitam Əsası və Əmək Stajı'}</h3>
            <p>{language === 'TR' ? 'İş Kanunu Madde 68, 69, 70, 74 ve 77 uyarınca yasal sınıflandırma' : language === 'ENG' ? 'Legal classification according to Articles 68, 69, 70, 74 and 77 of the Labor Code' : language === 'RU' ? 'Правовая классификация по статьям 68, 69, 70, 74 и 77 ТК АР' : 'AR Əmək Məcəlləsinin 68, 69, 70, 74 və 77-ci maddələri üzrə hüquqi təsnifat'}</p>
          </div>
        </div>

        <div className={styles.grid2}>
          <div className={styles.formGroup}>
            <label>{language === 'TR' ? 'Fesih nedeni (İş Kanunu Maddesi)' : language === 'ENG' ? 'Termination grounds (Labor Code Article)' : language === 'RU' ? 'Основание увольнения (Статья ТК)' : 'Xitam əsası (ƏM maddəsi)'}</label>
            <select
              value={terminationGround}
              onChange={(e) => setTerminationGround(e.target.value)}
            >
              {terminationGrounds.map((g) => (
                <option key={g.id} value={g.id}>
                  {t(g.label, language)}
                </option>
              ))}
            </select>
            <span className={styles.hint}>{t(calc4Ext.terminationReasonHint, language)}</span>
          </div>

          <div className={styles.formGroup}>
            <label>{language === 'TR' ? 'İşletmedeki toplam hizmet süresi (yıl)' : language === 'ENG' ? 'Total seniority at enterprise (years)' : language === 'RU' ? 'Общий стаж на предприятии (лет)' : 'Müəssisədə ümumi əmək stajı (il)'}</label>
            <input
              type="number"
              min="0"
              step="0.5"
              value={seniorityYears}
              onChange={(e) => setSeniorityYears(e.target.value)}
            />
            <span className={styles.hint}>
              ƏM 77.3 minimum müavinət əmsalı: <strong>{statutorySeveranceMultiplier}x OMA</strong>
            </span>
          </div>
        </div>

        {/* Condition 1 Warning: 74.1(d) */}
        {terminationGround === '74_1_d' && (
          <div className={styles.alertWarning}>
            <Attention className={styles.alertIcon} />
            <div>
              <h4>Diqqət: Məhkəmə Qərarı ilə Fəaliyyət Qabiliyyətsizliyi (ƏM 74.1.d)</h4>
              <p>
                Status: <strong>LEGAL_VERIFICATION_REQUIRED</strong>. ƏM 74 üzrə hüquqi status məhkəmə qərarı və
                qanunvericiliklə ayrıca təsdiq tələb edir. Bu halda sistem tərəfindən avtomatik işdənçıxarma
                müavinəti hesablanmır (0 AZN qəbul edilir).
              </p>
            </div>
          </div>
        )}

        {/* Notice Section: Only if 70_b (İxtisar) */}
        {terminationGround === '70_b' && (
          <div className={styles.noticeCard}>
            <div className={styles.noticeHeader}>
              <h4>{language === 'TR' ? 'İşten Çıkarma İhbar Süresi Güvencesi (Madde 77.1 ve 77.4)' : language === 'ENG' ? 'Redundancy Notice Period Guarantee (Art. 77.1 & 77.4)' : language === 'RU' ? 'Гарантия срока предупреждения при сокращении (Ст. 77.1 и 77.4)' : 'İxtisar üzrə Xəbərdarlıq Müddəti Təminatı (ƏM 77.1 və 77.4)'}</h4>
              <span className={styles.badge}>
                Staj üzrə qanuni müddət: {statutoryNoticeDays} təqvim günü ({statutoryNoticeMultiplier}x OMA)
              </span>
            </div>

            <div className={styles.noticeOptions}>
              <label className={styles.toggleConsent}>
                <input
                  type="checkbox"
                  checked={hasEmployeeConsent}
                  onChange={(e) => setHasEmployeeConsent(e.target.checked)}
                />
                <span>{language === 'TR' ? 'Çalışanın yazılı rızasıyla ihbar süresi yerine tazminat ödenmesi (Madde 77.4)' : language === 'ENG' ? 'Payment of compensation in lieu of notice upon written consent (Art. 77.4)' : language === 'RU' ? 'Выплата компенсации взамен срока предупреждения с письменного согласия (Ст. 77.4)' : 'İşçinin yazılı razılığı ilə xəbərdarlıq müddətinin əvəzinə kompensasiya ödənilməsi (ƏM 77.4)'}</span>
              </label>

              {hasEmployeeConsent && (
                <div className={styles.grid2}>
                  <div className={styles.formGroup}>
                    <label>Faktiki istifadə olunmuş (ötmüş) xəbərdarlıq günləri</label>
                    <input
                      type="number"
                      min="0"
                      max={statutoryNoticeDays}
                      value={elapsedNoticeCalendarDays}
                      onChange={(e) => setElapsedNoticeCalendarDays(e.target.value)}
                    />
                    <span className={styles.hint}>
                      Qalan kompensasiya olunacaq günlər: {Math.max(0, statutoryNoticeDays - elapsedNoticeCalendarDays)} gün (proporsional azalma)
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Condition 3: Optional Actual Severance vs Statutory Minimum */}
        <div className={styles.grid2}>
          <div className={styles.formGroup}>
            <label>Faktiki işdənçıxarma müavinəti (AZN, könüllü daxil etmə)</label>
            <input
              type="number"
              placeholder="Boş buraxıldıqda qanuni minimum götürülür"
              value={actualSeveranceAmount}
              onChange={(e) => setActualSeveranceAmount(e.target.value)}
            />
            <span className={styles.hint}>
              ƏM 77.3 minimum təminat müəyyən edir. Qanuni minimum müavinət vergi və sığortalardan tam azaddır (VM 102.1.4). Əlavə könüllü hissənin vergi rejimi ödənişin hüquqi əsasından asılı olaraq tətbiq edilir.
            </span>
          </div>

          <div className={styles.formGroup}>
            <label>{t(calc4Ext.terminationDate, language)}</label>
            <input
              type="date"
              value={terminationDate}
              onChange={(e) => setTerminationDate(e.target.value)}
            />
            <span className={styles.hint}>{t(calc4Ext.terminationDateHint, language)}</span>
          </div>
        </div>

        {/* Section 2: Cari Ayın Əməkhaqqı (Blok 0) */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>2</div>
          <div>
            <h3>{language === 'TR' ? 'Mevcut Ayın Fiilen Çalışılan Günlerine Göre Maaş (Blok 0)' : language === 'ENG' ? 'Current Month Salary for Actually Worked Days (Block 0)' : language === 'RU' ? 'Зарплата за фактически отработанные дни текущего месяца (Блок 0)' : 'Cari Ayın Faktiki İşlənmiş Günlərinə Görə Əməkhaqqı (Blok 0)'}</h3>
            <p>
              Xitam ayında işlənmiş iş günlərinə mütənasib əməkhaqqı: <strong>{monthlySalary} ₼ / {normDaysInMonth} gün × {actualDaysWorkedInMonth} gün = {((Number(monthlySalary) / (Number(normDaysInMonth) || 1)) * Number(actualDaysWorkedInMonth)).toFixed(2)} AZN (Gross)</strong>
            </p>
          </div>
        </div>

        <div className={styles.grid3}>
          <div className={styles.formGroup}>
            <label>Aylıq vəzifə maaşı (AZN)</label>
            <input
              type="number"
              min="0"
              value={monthlySalary}
              onChange={(e) => setMonthlySalary(e.target.value)}
            />
            <span className={styles.hint}>Ştat cədvəli üzrə aylıq tarif/vəzifə maaşı (TC-65 bazası: 3 400 AZN)</span>
          </div>

          <div className={styles.formGroup}>
            <label>{t(calc4Ext.normDays, language)}</label>
            <input
              type="number"
              min="1"
              max="31"
              value={normDaysInMonth}
              onChange={(e) => setNormDaysInMonth(e.target.value)}
            />
            <span className={styles.hint}>İstehsalat təqviminə əsasən ayın norması (Məs. Mart: 17 iş günü)</span>
          </div>

          <div className={styles.formGroup}>
            <label>{t(calc4Ext.actualDays, language)}</label>
            <input
              type="number"
              min="0"
              max={normDaysInMonth}
              value={actualDaysWorkedInMonth}
              onChange={(e) => setActualDaysWorkedInMonth(e.target.value)}
            />
            <span className={styles.hint}>Cari ayda xitamadək işlənmiş günlər (TC-65: 10 iş günü $\rightarrow$ 2 000 ₼)</span>
          </div>
        </div>

        {/* Section 3: İstifadə Edilməmiş Məzuniyyət Kompensasiyası (Blok 1 & 2) */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>3</div>
          <div>
            <h3>{language === 'TR' ? 'Kullanılmamış İzin Tazminatı (Madde 140, 144)' : language === 'ENG' ? 'Unused Vacation Compensation (Art. 140, 144)' : language === 'RU' ? 'Компенсация за неиспользованный отпуск (Ст. 140, 144)' : 'İstifadə Edilməmiş Məzuniyyət Kompensasiyası (ƏM 140, 144 və KM Qərarı)'}</h3>
            <p>
              Son 12 ayın orta əməkhaqqının 30,4-ə bölünməsi ilə OGQ₁₄₀ müəyyən edilir və hər iş ili üzrə ayrılıqda hesablanır
            </p>
          </div>
        </div>

        <div className={styles.grid2}>
          <div className={styles.formGroup}>
            <label>Son 12 ayın orta aylıq əməkhaqqı (AZN)</label>
            <input
              type="number"
              min="0"
              value={last12MonthsAverageSalary}
              onChange={(e) => setLast12MonthsAverageSalary(e.target.value)}
            />
            <span className={styles.hint}>
              ƏM 140.3 üzrə bir günlük məzuniyyət haqqı (OGQ₁₄₀): <strong>{dailyRateOGQ140} AZN/gün</strong> (30.4 əmsalı ilə)
            </span>
          </div>
        </div>

        {/* Vacation breakdown table */}
        <div className={styles.vacationTableBox}>
          <div className={styles.tableTop}>
            <span>İş illəri üzrə istifadə edilməmiş məzuniyyət günlərinin bölgüsü</span>
            <button type="button" className={styles.addBtn} onClick={addVacationRow}>
              + İş İli Əlavə Et
            </button>
          </div>

          {vacationBreakdown.map((item) => (
            <div key={item.id} className={styles.vacationRow}>
              <div className={styles.formGroup}>
                <label>İş ili</label>
                <input
                  type="text"
                  value={item.yearLabel}
                  onChange={(e) => updateVacationRow(item.id, 'yearLabel', e.target.value)}
                />
              </div>

              <div className={styles.formGroup}>
                <label>İstifadə edilməmiş günlər</label>
                <input
                  type="number"
                  min="0"
                  value={item.unusedDays}
                  onChange={(e) => updateVacationRow(item.id, 'unusedDays', e.target.value)}
                />
              </div>

              <div className={styles.formGroup}>
                <label>Təxmini brüt</label>
                <input
                  type="text"
                  disabled
                  value={`${((parseFloat(dailyRateOGQ140) || 0) * (parseFloat(item.unusedDays) || 0)).toFixed(2)} AZN`}
                />
              </div>

              {vacationBreakdown.length > 1 && (
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={() => removeVacationRow(item.id)}
                >
                  Sil
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Additional leave eligibility wizard (ƏM 115, 116, 117, 118-1) - Eligibility Based */}
        <div className={styles.additionalLeaveCard}>
          <div
            className={styles.accHeader}
            onClick={() => setShowAdditionalWizard(!showAdditionalWizard)}
          >
            <div>
              <h4 style={{ margin: 0 }}>
                Əlavə Məzuniyyət Hüququnun Yoxlanması (İşçinin Fərdi Hüquqi Statusu və Şərtləri Üzrə)
              </h4>
              <p style={{ margin: '4px 0 0 0', fontSize: '12.5px', color: '#64748b' }}>
                Konstitusiya Məhkəməsinin 18.02.2026 Qərarı (E-Qanun ƏM 144.3 keçid rejimi). Bu hüquq hamıya avtomatik şamil edilmir.
              </p>
            </div>
            <span className={styles.toggleTag}>
              {showAdditionalWizard ? '▲ Gizlət' : '▼ Hüquqi Şərtləri Yoxla'}
            </span>
          </div>

          {showAdditionalWizard && (
            <div className={styles.checklist}>
              <div style={{ gridColumn: '1 / -1', background: '#eff6ff', border: '1px solid #bfdbfe', padding: '10px 14px', borderRadius: '8px', fontSize: '12.5px', color: '#1e40af' }}>
                <strong>Keçid Vəziyyəti Qeydi:</strong> ƏM 144.3-ün hazırkı mətnində əlavə məzuniyyətlərə kompensasiya verilməməsi müddəası görünsə də, Konstitusiya Məhkəməsinin 18.02.2026 Qərarı ilə hüquqi əsasları mövcud olan işçilər üçün kompensasiya hüququ təsbit edilmişdir:
              </div>

              <div className={styles.checkItem}>
                <label>
                  <input
                    type="checkbox"
                    checked={hasHazardousConditions}
                    onChange={(e) => setHasHazardousConditions(e.target.checked)}
                  />
                  <span>Zərərli və ağır əmək şəraiti hüququ mövcuddur (ƏM 115)</span>
                </label>
                <span className={styles.checkDesc}>NK №66 siyahısı və attestasiya üzrə ən azı 6 təqvim günü</span>
              </div>

              <div className={styles.checkItem}>
                <label>
                  <input
                    type="checkbox"
                    checked={applySeniorityLeave}
                    onChange={(e) => setApplySeniorityLeave(e.target.checked)}
                  />
                  <span>
                    Əmək stajına görə əlavə günlər hüququ tətbiq edilsin (ƏM 116): <strong>{additionalLeaveCalculation.seniorityDays} gün</strong>
                  </span>
                </label>
                <span className={styles.checkDesc}>
                  Staj 5-10 il: 2 gün, 10-15 il: 4 gün, 15 ildən çox: 6 gün (yalnız hüququ olduqda tətbiq edilir)
                </span>
              </div>

              <div className={styles.checkItem}>
                <label>
                  <input
                    type="checkbox"
                    checked={isLiberatedTerritorySpecialist}
                    onChange={(e) => setIsLiberatedTerritorySpecialist(e.target.checked)}
                  />
                  <span>İşğaldan azad edilmiş ərazilərdə çalışan mütəxəssis statusu (ƏM 118-1)</span>
                </label>
                <span className={styles.checkDesc}>Müvafiq ərazilərdə fəaliyyəti təsdiq edildikdə 5 təqvim günü</span>
              </div>

              <div className={styles.checkItem}>
                <label>
                  <span>Uşaqlı işçilər üçün fərdi hüquqi status (ƏM 117):</span>
                </label>
                <select
                  value={childrenUnder14Count}
                  onChange={(e) => setChildrenUnder14Count(e.target.value)}
                  style={{ height: '38px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
                >
                  <option value="0">Hüquq yoxdur və ya 1 uşaq (0 gün)</option>
                  <option value="2">14 yaşınadək 2 uşağı olan qadın/tək ata (2 gün)</option>
                  <option value="3">14 yaşınadək 3 və daha çox uşaq və ya əlilliyi olan uşaq (5 gün)</option>
                </select>
              </div>

              <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
                <button
                  type="button"
                  className={styles.addBtn}
                  onClick={applyAdditionalDaysToVacation}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '8px',
                    background: '#eff6ff',
                    border: '1px solid #93c5fd',
                    color: '#1d4ed8',
                    cursor: 'pointer',
                    fontWeight: 600,
                  }}
                >
                  + Təsdiq edilmiş {additionalLeaveCalculation.totalEligibleDaysPerYear} əlavə günü məzuniyyət cədvəlinə əlavə et
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Section 4: Son 2 Təqvim Ayının Qazancı (ƏM 177.2 OMA) */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>4</div>
          <div>
            <h3>Son 2 Təqvim Ayının Qazancı və Orta Aylıq Əməkhaqqı Bazasının (OMA) Təyini</h3>
            <p>AR Əmək Məcəlləsinin 177.2-ci maddəsinə uyğun olaraq iş günləri üzrə OGQ₁₇₇ hesablanması</p>
          </div>
        </div>

        <div className={styles.grid3}>
          <div className={styles.formGroup}>
            <label>Son 2 ayın cəmi qazancı (AZN)</label>
            <input
              type="number"
              min="0"
              value={lastTwoMonthsTotalEarnings}
              onChange={(e) => setLastTwoMonthsTotalEarnings(e.target.value)}
            />
            <span className={styles.hint}>Müavinət hesablanan aydan əvvəlki 2 təqvim ayının cəmi</span>
          </div>

          <div className={styles.formGroup}>
            <label>Son 2 ayın cəmi faktiki iş günləri</label>
            <input
              type="number"
              min="1"
              value={lastTwoMonthsWorkDays}
              onChange={(e) => setLastTwoMonthsWorkDays(e.target.value)}
            />
            <span className={styles.hint}>
              ƏM 177.2 üzrə bir günlük orta əməkhaqqı (OGQ₁₇₇): <strong>{dailyRateOGQ177} AZN/gün</strong>
            </span>
          </div>

          <div className={styles.formGroup}>
            <label>Növbəti ayın iş günləri (Model B üçün)</label>
            <input
              type="number"
              min="1"
              max="31"
              value={nextMonthWorkDays}
              onChange={(e) => setNextMonthWorkDays(e.target.value)}
            />
            <span className={styles.hint}>Alternativ Model B simulyasiyası üçün nəzərdə tutulur</span>
          </div>
        </div>

        {/* Submit action */}
        <div className={styles.calcActions}>
          <button type="button" onClick={handleCalculate}>
            Yekun Son Haqq-Hesabı Hesabla
          </button>
        </div>
      </div>

      {/* Exhaustive Legal Explanations */}
      <div className={styles.legalExplanation}>
        <div className={styles.header}>
          <Info />
          <h3>Əmək Müqaviləsinə Xitam Zamanı Qanunvericilik Əsasları və Tətbiq Qaydaları</h3>
        </div>

        <div className={styles.articleList}>
          <div className={styles.articleItem}>
            <h4>1. İşdənçıxarma Müavinəti (ƏM m.77.3 və m.77.7)</h4>
            <p>
              İşçilərin sayı azaldıqda və ya ştatları ixtisar edildikdə (ƏM 70 "b") və müəssisə ləğv edildikdə (ƏM 70 "a")
              işəgötürən işçiyə əmək stajından asılı olaraq qanuni minimum işdənçıxarma müavinəti ödəməlidir: 1 ilədək stajda —
              azı 1.0 misli; 1 ildən 5 ilədək — azı 1.4 misli; 5 ildən 10 ilədək — azı 1.7 misli; 10 ildən çox — azı 2.0 misli.
              Hərbi xidmətə çağırılma və 6 aydan çox əmək qabiliyyətinin fasiləsiz itirilməsi hallarında (ƏM 74.1 a, c) azı 2.0 misli,
              vəfat etdikdə isə (ƏM 74.1 e) vərəsələrinə azı 3.0 misli orta aylıq əməkhaqqı ödənilir.
            </p>
          </div>

          <div className={styles.articleItem}>
            <h4>2. Xəbərdarlıq Müddətinin Əvəzinə Kompensasiya (ƏM m.77.1 və m.77.4)</h4>
            <p>
              Xəbərdarlıq müddəti və onun kompensasiya ilə əvəz edilməsi mexanizmi YALNIZ ƏM 70 "b" (ixtisar) halına şamil edilir.
              İşəgötürən işçinin yazılı razılığı ilə xəbərdarlıq müddətini əməkhaqqının saxlanıldığı müvafiq əmsallarla (0.5x, 0.9x,
              1.4x, 2.0x) birdəfəlik kompensasiya ilə əvəz edə bilər. Xəbərdarlıq müddəti ərzində əmək müqaviləsinə xitam verildikdə
              ödəniş xəbərdarlıq müddətinin ötmüş hissəsinə mütənasib azaldılır.
            </p>
          </div>

          <div className={styles.articleItem}>
            <h4>3. İstifadə Edilməmiş Məzuniyyət Kompensasiyası və Konstitusiya Məhkəməsinin Qərarı</h4>
            <p>
              ƏM 140.3-ə əsasən, bir günlük məzuniyyət haqqı son 12 ayın qazancının 30,4-ə bölünməsi yolu ilə tapılır.
              AR Konstitusiya Məhkəməsinin 18.02.2026-cı il tarixli Qərarına əsasən, əmək müqaviləsinə xitam verilərkən işçinin
              yalnız əsas məzuniyyəti deyil, həm də ƏM 115, 116, 117 və 118-1-ci maddələri üzrə istifadə edilməmiş əlavə
              məzuniyyət günləri üçün də qanunvericilikdə müvafiq dəyişiklik edilənədək pul kompensasiyası ödənilməlidir.
            </p>
          </div>

          <div className={styles.articleItem}>
            <h4>4. Vergi və Sosial Sığorta Tutulmaları üzrə İki Yanaşma</h4>
            <p>
              İşdənçıxarma müavinəti və xəbərdarlıq kompensasiyası AR Vergi Məcəlləsinin 102.1.4-cü maddəsi və "Sosial sığorta
              haqqında" Qanunun 15-ci maddəsinə əsasən gəlir vergisi, MDSS, İTS və İŞS-dən tam azaddır. İstifadə edilməmiş
              məzuniyyət kompensasiyası üzrə isə:
              <br />
              <strong>Yanaşma A (NK №58, bənd 1):</strong> Qüvvədə olan Nazirlər Kabinetinin 58 nömrəli Qərarının birbaşa
              müddəasına əsasən məzuniyyət kompensasiyasına MDSS hesablanmır (0 AZN).
              <br />
              <strong>Yanaşma B (DVX 11.08.2026 izahı):</strong> Dövlət Vergi Xidmətinin rəsmi inzibati izahına əsasən,
              istifadə edilməmiş məzuniyyət günlərinə görə verilən kompensasiya hər iş ili üzrə ayrılıqda vergi və MDSS-ə cəlb olunur
              (hər il üçün 200 AZN vergi güzəşti tətbiq olunur).
            </p>
          </div>

          <div className={styles.articleItem}>
            <h4>5. Hüquqi Məsuliyyət və Simulyativ Xarakter Qeydi</h4>
            <p>
              Bu kalkulyator hüquqi və maliyyə hesablamalarının ilkin/simulyativ qiymətləndirilməsi üçün nəzərdə tutulub. Xüsusi hallarda əmək müqaviləsinin şərtləri, kollektiv müqavilə, işçinin statusu və qüvvədə olan qanunvericilik nəzərə alınmaqla fərdi hüquqi/mühasibat yoxlaması tələb oluna bilər.
            </p>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Calculator4